// src/web-app/lib/auth/bootstrap.js
// Web app bootstrap - simplified, no Tauri/engine dependencies
import { completeEmailLinkSignIn, onUser, signInWithGoogle, signInWithEmail, createAccount, getRedirectResult } from "./firebase.js";
import { getAuth } from "firebase/auth";
import { ensureSession, getClientId, getAccessToken } from "./session.js";

export async function startFootcheckApp() {
  console.log("[BOOTSTRAP] startFootcheckApp called at", new Date().toISOString());
  
  await completeEmailLinkSignIn().catch(() => {});
  console.log("[BOOTSTRAP] Email link sign-in check completed");

  // Check for redirect result first - this handles the case where we're returning from Google
  const redirectResult = await getRedirectResult();
  console.log("[BOOTSTRAP] Redirect result:", redirectResult ? "Found user" : "None");
  if (redirectResult && redirectResult.user) {
    console.log("[BOOTSTRAP] Sign-in successful via redirect", redirectResult.user.email);
    try {
      await ensureSession(navigator.platform, "web-app");
      console.log("client_id:", getClientId());
      const peek = (await getAccessToken()).slice(0, 24);
      console.log("access token (first 24):", peek, "…");
      return;
    } catch (e) {
      console.error("Session setup failed after redirect:", e);
      throw e;
    }
  }

  // Check if we're already authenticated
  const auth = getAuth();
  console.log("[AUTH] Waiting for Firebase auth state to initialize...");
  
  // Wait up to 5 seconds for auth state to initialize
  const authUser = await new Promise((resolve) => {
    if (auth.currentUser) {
      console.log("[AUTH] User already available:", auth.currentUser.email);
      resolve(auth.currentUser);
      return;
    }
    
    const timeoutId = setTimeout(() => {
      console.warn("[AUTH] Auth state timeout - no user found");
      unsubscribe();
      resolve(null);
    }, 5000);
    
    // Listen for auth state change (fires once when Firebase initializes)
    const unsubscribe = auth.onAuthStateChanged((user) => {
      clearTimeout(timeoutId);
      unsubscribe();
      if (user) {
        console.log("[AUTH] User authenticated:", user.email);
      } else {
        console.warn("[AUTH] No authenticated user");
      }
      resolve(user);
    });
  });
  
  if (authUser) {
    console.log("[BOOTSTRAP] User already authenticated:", authUser.email);
    try {
      console.log("[BOOTSTRAP] Calling ensureSession...");
      await ensureSession(navigator.platform, "web-app");
      console.log("[BOOTSTRAP] ensureSession completed successfully");
      console.log("[BOOTSTRAP] client_id:", getClientId());
      const peek = (await getAccessToken()).slice(0, 24);
      console.log("[BOOTSTRAP] access token (first 24):", peek, "…");
      return;
    } catch (e) {
      console.error("[BOOTSTRAP] Session setup failed for existing user:", e);
      throw e;
    }
  }

  // If we get here, we need to authenticate
  console.warn("[BOOTSTRAP] No authenticated user found, throwing error");
  throw new Error("No authenticated user found. Please use email/password authentication or Google sign-in.");
}

export async function authenticateWithEmail(email, password) {
  try {
    const user = await signInWithEmail(email, password);
    await ensureSession(navigator.platform, "web-app");
    return user;
  } catch (error) {
    console.error("Email authentication error:", error);
    throw error;
  }
}

export async function createAccountWithEmail(email, password) {
  try {
    const user = await createAccount(email, password);
    await ensureSession(navigator.platform, "web-app");
    return user;
  } catch (error) {
    console.error("Account creation error:", error);
    throw error;
  }
}






